// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table p[data-v-12909ecd]{margin:0}", "",{"version":3,"sources":["webpack://./modules/frontend/themes/ensotyres/assets/js/components/HelpAdvice/UnderstandingYourTyres.vue"],"names":[],"mappings":"AAEQ,yBACI,QADZ","sourcesContent":["\n    table {\n        p {\n            margin: 0;\n        }\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
